module.exports = __webpack_public_path__ + "static/ocular-safety-928242656fdf0abe97b400f85417076f.png";